import React from "react";
import { Newspaper, Pin } from "lucide-react";
import { Button } from "./ui/button";
import { Pencil } from "lucide-react";
import { Link } from "react-router-dom";
import DOMPurify from "dompurify";

const PURIFY_CONFIG = {
  ALLOWED_TAGS: ["a", "b", "strong", "i", "em", "u", "p", "br", "ul", "ol", "li", "h3", "h4", "span", "img"],
  ALLOWED_ATTR: ["href", "target", "rel", "src", "alt", "style"],
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel|data:image\/[a-z]+;base64,)|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
};

export default function NewsPanel({ items = [], canEdit = false }) {
  return (
    <div className="rounded-xl border border-border bg-card p-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center">
            <Newspaper className="w-4 h-4 text-primary" />
          </div>
          <h3 className="text-[15px] font-semibold">UCvigil News</h3>
        </div>
        {canEdit && (
          <Button asChild variant="ghost" size="sm" className="h-8 gap-1 text-muted-foreground hover:text-foreground">
            <Link to="/settings/news"><Pencil className="w-3.5 h-3.5" /> Edit</Link>
          </Button>
        )}
      </div>
      <div className="mt-4 space-y-4">
        {items.length === 0 && (
          <div className="text-[12.5px] text-muted-foreground">No announcements right now.</div>
        )}
        {items.map((n) => (
          <a key={n.id} href={n.url || "#"} target={n.url ? "_blank" : "_self"} rel="noopener noreferrer" className="block group">
            <div className="flex items-start gap-2">
              {n.pinned ? (
                <Pin className="w-3.5 h-3.5 text-primary mt-1" />
              ) : (
                <Pin className="w-3.5 h-3.5 text-muted-foreground mt-1 opacity-40" />
              )}
              <div className="min-w-0">
                {n.tag && <div className="text-[10px] font-bold tracking-wider text-primary uppercase">{n.tag}</div>}
                <div className="text-[13.5px] font-semibold leading-snug text-foreground group-hover:text-primary transition-colors">{n.title}</div>
                {n.excerpt && !n.body && (
                  <div className="mt-0.5 text-[12px] text-muted-foreground leading-snug">{n.excerpt}</div>
                )}
                {n.body && (
                  <div
                    className="mt-0.5 text-[12px] text-muted-foreground leading-snug line-clamp-3 [&_a]:text-primary [&_a]:underline [&_ul]:list-disc [&_ul]:pl-4"
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(n.body, PURIFY_CONFIG) }}
                  />
                )}
                {n.date && <div className="mt-1 text-[11px] text-muted-foreground">{n.date}</div>}
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
